import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
// common components
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import CustomAvatar from './../../../common/Avatar/Avatar';
import Loader from './../../../common/Loader/Loader';
import './BatchList.scss';

const BatchList = ({ manageBatch, batchDetails, batchList }) => {
	if (batchList && batchList.length > 0) {
		return (
			<div className='BatchList'>
				{batchList.map(item => (
					<div className="row card-view" key={item.id}>
						<div className="col col-lg-3 card-heading one ">
							<CustomAvatar name={item.name} />
							<div className="heading">
								<div className="title" onClick={() => batchDetails(item.id)}>{item.name}</div>
								<Tooltip title={item.description} placement="bottom">
									<div className="desc ellipse">{item.description}</div>
								</Tooltip>
							</div>
						</div>
						<div className="col-12 col-lg details two ">
							<div className="row card-detail">
								<div className="col">
									<div className="title">course name</div>
									<div className="value">{item.course_name}</div>
								</div>
								<div className="col">
									<div className="title">date</div>
									<div className="value">
										{moment(item.start_date).format('DD MMM YYYY')}&nbsp;-&nbsp;
										{moment(item.end_date).format('DD MMM YYYY')}
									</div>
								</div>
								<div className="col">
									<div className="title">location</div>
									<div className="value">{item.city ? `${item.city}${item.country && ','} ${item.country}` : '-'}</div>
								</div>

								{/* <div className="col">
									<div className="title">time</div>
									<div className="value">
										{moment(item.start_time, 'HH:mm:ss').format('hh:mm a')}&nbsp;-&nbsp;
										{moment(item.end_time, 'HH:mm:ss').format('hh:mm a')}
									</div>
								</div>							 */}
							</div>
						</div>
						<div className="col cardview-actions three">
							<div className="line" />
							<CustomButton
								iconOnly
								iconName='edit'
								onClick={() => manageBatch(true, 'edit', item.id)}
							/>
							<CustomButton
								iconOnly
								iconName='delete'
								onClick={() => manageBatch(true, 'delete', item.id)}
							/>
						</div>
					</div>
				))}
			</div>
		);
	}
	return (<Loader />);
}

BatchList.propTypes = {
	manageBatch: PropTypes.func,
	batchDetails: PropTypes.func,
	batchList: PropTypes.instanceOf(Array)
};

BatchList.defaultProps = {
	manageBatch: () => { },
	batchDetails: () => { },
	batchList: []
};

export default BatchList;



// WEBPACK FOOTER //
// ./components/Batch/BatchList/BatchList.js